import { Book } from 'utility/interfaces';

export const books: Book[] = [
    {
        title: 'Richest Man in Babylon',
        image: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/the-richest-man-in-babylon-31.jpeg?alt=media&token=c02c3df9-75ef-41d8-9b19-a2ad170bcb86',
        linkUrl: 'https://www.goodreads.com/book/show/1052.The_Richest_Man_in_Babylon',
    },
    {
        title: 'Thinking Fast & Slow',
        image: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/Thinking%2C_Fast_and_Slow.jpeg?alt=media&token=587c7152-3b44-435e-99ca-e58e37e1d821',
        linkUrl: 'https://www.goodreads.com/book/show/11468377-thinking-fast-and-slow',
    },
    {
        title: 'Freakonomics',
        image: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/Freakonomics.jpeg?alt=media&token=6ba131b8-f19d-4399-b19a-180f99cc9007',
        linkUrl: 'https://www.goodreads.com/book/show/1202.Freakonomics',
    },
    {
        title: '1984',
        image: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/Audiokniha-1984-George-Orwell.jpeg?alt=media&token=4d7ef2c0-5203-435b-b99b-7c83884e6553',
        linkUrl: 'https://www.goodreads.com/book/show/40961427-1984?',
    },
    {
        title: 'Hitchhikers guide to the galaxy',
        image: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/hitchhiker-s-guide-douglas-adams-657242_451_700.webp?alt=media&token=2b878620-6960-4314-bf5f-bbc8be031a19',
        linkUrl: 'https://www.goodreads.com/book/show/386162.The_Hitchhiker_s_Guide_to_the_Galaxy',
    },
    {
        title: 'Clean Code',
        image: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/_i6bDeoCQzsC.jpeg?alt=media&token=4136e84c-7d1e-4440-833d-c9d6d8406dbe',
        linkUrl: 'https://www.goodreads.com/book/show/3735293-clean-code',
    },
    {
        title: 'Restaurant at the End of the Universe',
        image: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/8695._SY475_.jpg?alt=media&token=f0e7c9b4-d6db-4dde-8af5-3d5a3c3d53ec',
        linkUrl: 'https://www.goodreads.com/book/show/8695.The_Restaurant_at_the_End_of_the_Universe',
    },
    {
        title: 'A Random Walk Down Wall Street',
        image: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/40242274.jpeg?alt=media&token=aedb66ce-16e7-4a42-bbc4-7e3891365cdb',
        linkUrl: 'https://www.goodreads.com/book/show/40242274-a-random-walk-down-wall-street',
    },
    {
        title: 'The Inmates Are Running the Asylum',
        image: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/41%2BEv14Di4L._AC_UF1000%2C1000_QL80_.jpg?alt=media&token=2f04190b-37f8-481a-a2f0-d4b25304d2d2',
        linkUrl: 'https://www.goodreads.com/en/book/show/44098',
    },
    {
        title: 'The Subtle Art of Not Giving a F*ck',
        image: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/The_Subtle_Art_of_Not_Giving_a_F_ck_by_Mark_Manson_-_Book_Cover.png?alt=media&token=249d7ee7-a529-4915-971a-fdf76bf5647e',
        linkUrl: 'https://en.wikipedia.org/wiki/The_Subtle_Art_of_Not_Giving_a_F*ck',
    },
];
